import { Chip, tooltipClasses } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { createElement } from "react";
import { useTranslation } from "react-i18next";
import { TbEye } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { passengerWelcomeTeamVisibilities } from "@/constants/PassengerWelcomeTeamVisibility";
import { checkBit } from "@/helpers/bitwise";
import { NoMaxWidthTooltip } from "@/pages/DriverStatus.tsx/components/DriverStatusColumnTooltip";
import HotelStatusTooltip from "@/pages/HotelPlanning/arrival/components/table/components/HotelStatusTooltip";
import { PassengerTypes } from "@/types/global";
import { IPlanPassenger } from "@/types/tasks.types";

export function PassengerVisibilityCell({
    value,
    isFlightArrival,
    passengerType,
}: {
    value: PassengerTypes;
    isFlightArrival: boolean;
    passengerType: PassengerTypes;
}) {
    const { t } = useTranslation();
    const status = passengerWelcomeTeamVisibilities.find(
        (status) =>
            (passengerType !== PassengerTypes.MANUAL && !status.value && isFlightArrival) ||
            (passengerType !== PassengerTypes.MANUAL && !isFlightArrival && status.value) ||
            checkBit(status.value, value)
    );

    return (
        <div className="flex items-center py-1 h-full">
            {status && (
                <NoMaxWidthTooltip
                    arrow
                    sx={{
                        [`& .${tooltipClasses.tooltip}`]: {
                            backgroundColor: "white",
                            border: "none",
                            padding: "0px !important",
                            fontSize: 12,
                            maxWidth: "200px !important",
                        },
                    }}
                    title={<HotelStatusTooltip status={status} />}
                >
                    <Chip
                        sx={{
                            backgroundColor: status.bg,
                            color: status.text,
                            fontWeight: 500,
                            fontSize: "12px !important",
                        }}
                        icon={createElement(status.component(), {
                            fontSize: 14,
                            color: status.text,
                        })}
                        label={t(status.label || "")}
                    />
                </NoMaxWidthTooltip>
            )}
        </div>
    );
}

export const PassengerVisibilityColumn = ({ t }: { t: TFunction }): GridColDef<IPlanPassenger<"api">> => {
    return {
        field: "welcomeTeamVisibility",
        headerName: t("welcomeTeamVisibility"),
        minWidth: 155,
        valueGetter: (_val, row) => row.extras,
        renderHeader: (params) => <TableHeader Component={TbEye} title={params.colDef.headerName!} />,
        renderCell: ({ value, row }) => (
            <PassengerVisibilityCell
                passengerType={row.passengerType}
                isFlightArrival={row.isFlightArrival}
                value={value}
            />
        ),
    };
};
export default PassengerVisibilityColumn;
